import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import {
  ApplicationContextService,
  RolePermissionService,
} from 'lib-core-shared';
import { ControlBaseDirective } from '../../directives/control-base.directive';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-modal-type-input',
  templateUrl: './modal-type-input.component.html',
  styleUrls: ['./modal-type-input.component.scss'],
})
export class ModalTypeInputComponent extends ControlBaseDirective implements AfterViewInit{
  @Input() source: any[] = [];
  @Input() sourceType: string = '';
  @Input() defaultOptionMessage!: string;
  @Input() defaultOptionDisabled: boolean | null = null;
  @Input() sourceIsLoading: boolean = false;
  @Input() optionsType: string = 'object';
  @ViewChild('taxonomyModal') public taxonomyModal!: ElementRef;
  value: any;

  ngbModalOption: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    size: 'md',
  };

  constructor(
    public roleService: RolePermissionService,
    public applicationContext: ApplicationContextService,
    public modalService: NgbModal,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super(roleService, applicationContext);
  }
  
  public ngAfterViewInit(): void {
    if(this.formCtrl.value){
      this.valueSelected(this.formCtrl.value);
      this.changeDetectorRef.detectChanges();
    };
  }
  public openModal() {
    if (this.roleService.userHasPermission(this.permission)) {
      this.modalService.open(this.taxonomyModal, this.ngbModalOption);
    } 
  }
  public closeModal() {
    if(!this.value){
      this.formCtrl.markAsTouched();
    }
    this.modalService.dismissAll();
  }

  public toggleTreeItem(item: any): void {
    item.expanded = !item.expanded;
  }

  public valueSelected(item: any, selectedViaModal?: boolean) {
    if (item?.children?.length > 0) {
      item.expanded = !item.expanded;
    } else{
      if (this.externalTrigger) {
        this.externalTrigger=false
      }
      this.value =  item.code + ' - ' + item.name;
      this.formCtrl.setValue(item);
      this.closeModal();
      if (selectedViaModal) {
        this.formCtrl.markAsDirty();
      }
    }
  }
}
